import React, { useState, useEffect } from "react";
import { SERVER_BASE } from "../config/server";
import apiClient from "../utils/apiClient";
import Swal from "sweetalert2";
import { useNavigate, useLocation } from "react-router-dom";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronCircleLeft } from "@fortawesome/free-solid-svg-icons";
const ReturnSlip = ({ accessOfDepartments }) => {
  const [date, setDate] = useState("");
  const [issueSlipNumber, setIssueSlipNumber] = useState("");
  const [issueDetails, setIssueDetails] = useState(null);
  const [returnQuantities, setReturnQuantities] = useState({});
  const [locations, setLocations] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState({});
  const [availableQuantities, setAvailableQuantities] = useState({});
  const [returnRemarks, setReturnRemarks] = useState({}); // State for remarks
  const [profileDetails, setProfileDetails] = useState(null); // State for profile details
  const code = localStorage.getItem('code');
  const email = localStorage.getItem('email');
  const role = localStorage.getItem('role');
  const name = localStorage.getItem('name');
  const token = localStorage.getItem('token')
  const badgeId = localStorage.getItem('badgeId');
  const navigate = useNavigate();
  const location = useLocation();
  const type = location?.state?.type;                       // "IR" or "PR"
  const issueSlipCodeState = location?.state?.issueSlipCode;
  const projectRequirementId = location?.state?.projectRequirementId;
  

  useEffect(() => {
    // 🔹 IR Return flow
    if (type === "IR" && issueSlipCodeState) {
      setIssueSlipNumber(issueSlipCodeState);
      fetchIssueDetails(issueSlipCodeState);
    }
  
    // 🔹 PR Return flow
    if (type === "PR" && projectRequirementId) {
      fetchRequirementIssueDetails(projectRequirementId);
    }
  }, [type, issueSlipCodeState, projectRequirementId]);
  
  useEffect(() => {
    fetchProfileDetails();
    fetchLocations();
  }, []);
  const fetchLocations = () => {
    apiClient
      .get(SERVER_BASE + "/getLocations", {
        params: { code }, headers: {
          Authorization: `Bearer ${token}`, // Add the JWT token in the header
        }
      })
      .then((response) =>
        setLocations(
          response.data.map((location) => ({
            value: location.location,
            label: location.location,
          }))
        )
      )
      .catch((error) => console.error(error));
  };
  const fetchProfileDetails = async () => {
    try {
      const response = await apiClient.get(`${SERVER_BASE}/getProfile`, { params: { email, role } });
      setProfileDetails(response.data?.[0] || null); // Assume the first row contains the profile data
    } catch (err) {
      console.error('Error fetching profile details:', err);
      setProfileDetails(null);
    }
  };

  const fetchIssueDetails = async (issueSlipNumber) => {
    if (!issueSlipNumber) {
      Swal.fire({
        icon: 'warning',
        text: 'Please enter an issue slip number.',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true
      });
      return;
    }

    try {
      const response = await apiClient.get(`${SERVER_BASE}/getIssueDetails`, {
        params: { issueSlipNumber },
      });
      setIssueDetails(response.data);

      const initialQuantities = response.data.items.reduce((acc, item) => {
        acc[item.itemName] = "";
        return acc;
      }, {});
      setReturnQuantities(initialQuantities);

      const initialRemarks = response.data.items.reduce((acc, item) => {
        acc[item.itemName] = "";
        return acc;
      }, {});
      setReturnRemarks(initialRemarks);
    } catch (error) {
      console.error("Error fetching issue details:", error);
      alert(error.response?.data?.message || "Failed to fetch issue details.");
    }
  };
  // 🔹 Fetch PR issue details for return
  const fetchRequirementIssueDetails = async (projectRequirementId) => {
    try {
      const response = await apiClient.get(
        `${SERVER_BASE}/getIssueFromRequirementDetails`,
        { params: { projectRequirementId } }
      );
  
      setIssueDetails(response.data);
  
      // Init quantities
      const initialQuantities = response.data.items.reduce((acc, item) => {
        acc[item.itemName] = "";
        return acc;
      }, {});
      setReturnQuantities(initialQuantities);
  
      const initialRemarks = response.data.items.reduce((acc, item) => {
        acc[item.itemName] = "";
        return acc;
      }, {});
      setReturnRemarks(initialRemarks);
  
    } catch (error) {
      console.error("Error fetching PR issue details:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "Failed to fetch requirement issue details",
        position: "top-end",
        toast: true,
        timer: 3000,
        showConfirmButton: false,
      });
    }
  };
  
  const handleQuantityChange = (itemName, value) => {
    setReturnQuantities((prevQuantities) => ({
      ...prevQuantities,
      [itemName]: value,
    }));
  };

  const handleRemarksChange = (itemName, value) => {
    setReturnRemarks((prevRemarks) => ({
      ...prevRemarks,
      [itemName]: value,
    }));
  };
  const handleLocationChange = async (itemName, selected) => {
    setSelectedLocations((prev) => ({
      ...prev,
      [itemName]: selected,
    }));

    if (selected) {
      const item = issueDetails.items.find((inv) => inv.itemName == itemName);

      const available = await fetchAvailableQuantity(item?.itemId, selected.value, "As Stock");
      setAvailableQuantities((prev) => ({
        ...prev,
        [itemName]: available,
      }));
    }
  };
  const fetchAvailableQuantity = async (itemId, location, status) => {
    try {
      const response = await apiClient.get(`${SERVER_BASE}/getAvailableQuantity`, {
        params: { item: itemId, location, status, code, department: issueDetails?.receivingDepartment },
        headers: { Authorization: `Bearer ${token}` },
      });

      return response.data.availableQuantity || 0;
    } catch (error) {
      console.error("Error fetching available quantity:", error);
      return 0;
    }
  };
  const generateReturnSlip = async () => {
    if (!date)
      return Swal.fire({ toast: true, position: "top-end", icon: "warning", title: "Please select Date", showConfirmButton: false, timer: 2000 });
  
    const payload = {
      returnDate: date,
      requestNumber: issueSlipNumber,   // used only for IR
      returnedItems: Object.entries(returnQuantities).map(([itemName, returnQuantity]) => {
        const item = issueDetails.items.find((i) => i.itemName === itemName);
        return {
          requestItemId: item.requestItemId,
          itemId: item?.itemId,
          itemName,
          returnQuantity: returnQuantity || 0,
          issuedQuantity: item ? item.returnableQuantity : 0, // allowed to return
          returnable: item?.returnable,
          returnRemark: returnRemarks[itemName] || "",
          returnLocation: selectedLocations[itemName] || "",
          availableQuantity: availableQuantities[itemName] ?? 0
        };
      }),
      returnedBy: name,
      returnedByBadge: badgeId,
    };
  
    // ----------------- 🔍 Validations -----------------
    const hasReturned = payload.returnedItems.some(item => item.returnQuantity > 0);
    if (!hasReturned) {
      Swal.fire({
        icon: 'warning',
        title: 'Validation Error',
        text: 'At least one item must have a return quantity.',
        position: 'top-end',
        toast: true,
        timer: 2000,
        showConfirmButton: false,
      });
      return;
    }
  
    for (const item of payload.returnedItems) {
      if (item.returnQuantity > item.issuedQuantity) {
        Swal.fire({
          icon: 'warning',
          title: 'Validation Error',
          text: `Return quantity for "${item.itemName}" cannot exceed issued quantity (${item.issuedQuantity}).`,
          position: 'top-end',
          toast: true,
          timer: 2000,
          showConfirmButton: false,
        });
        return;
      }
  
      // 🔹 Available qty validation ONLY for IR (PR does not affect stock)
      if (type === "IR" && item.returnQuantity > item.availableQuantity) {
        Swal.fire({
          icon: 'warning',
          title: 'Validation Error',
          position: 'top-end',
          toast: true,
          timer: 2000,
          showConfirmButton: false,
          text: `Return quantity for "${item.itemName}" cannot exceed available quantity (${item.availableQuantity}).`,
        });
        return;
      }
    }
  
    // ----------------- 🚀 API Call (IR / PR switch) -----------------
    try {
  
      // 🔹 IR Return Flow
      if (type === "IR") {
        await apiClient.post(`${SERVER_BASE}/generateReturnSlip`, payload);
      }
  
      // 🔹 PR Return Flow
      if (type === "PR") {
        await apiClient.post(`${SERVER_BASE}/generateReturnSlipForRequirement`, {
          ...payload,
          projectRequirementId   // 🔥 comes from navigation state
        });
      }
  
      Swal.fire({
        icon: 'success',
        title: 'Created!',
        text: 'Return slip generated successfully!',
        position: 'top-end',
        toast: true,
        timer: 2000,
        showConfirmButton: false,
      });
  
      setIssueSlipNumber("");
      setIssueDetails(null);
      setReturnQuantities({});
      setReturnRemarks({});
      navigate(-1);
  
    } catch (error) {
      console.error("Error generating return slip:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "Failed to generate return slip",
      });
    }
  };
  

  return (
    <>
      <div className="formcontainer mt-5">
        <div className="d-flex align-items-end mb-3">
          <button
            type="button"
            className="btn btn-secondary btn-sm me-3"
            onClick={() => navigate(-1)}
          >
            <FontAwesomeIcon icon={faChevronCircleLeft} /> Back
          </button>
          <h4 className="mb-0">Generate Return Slip</h4>
        </div>
        <div className="col-md-1 mb-2">
          <label className="form-label">Return Date</label>
          <input type="date" className="form-control" value={date} onChange={(e) => setDate(e.target.value)} />
        </div>
        {issueDetails && (
          <div>
            <p>
              <strong>Requesting Department:</strong> {issueDetails.receivingDepartment}
            </p>
            <p>
              <strong>Issuer Department:</strong> {issueDetails.issuerDepartment}
            </p>

            <div className="row">
              <div className="col-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row fw-bold mb-2">
                      <div className="col-md-3">Item</div>
                      <div className="col-md-2">Location</div>
                      <div className="col-md-1">Avail. Qty</div>
                      <div className="col-md-1">Issued</div>
                      {/* <div className="col-md-1">Return</div> */}
                      <div className="col-md-2">Return Qty</div>
                      <div className="col-md-1">UOM</div>
                      <div className="col-md-2">Remarks</div>
                    </div>

                    {issueDetails.items.map((item) => (
                      <div className="row mb-2 align-items-center" key={item.itemName}>

                        {/* Item Name */}
                        <div className="col-md-3">
                          <input
                            type="text"
                            className="form-control"
                            value={item.itemName}
                            readOnly
                          />
                        </div>

                        {/* Location Dropdown */}
                        <div className="col-md-2">
                          <Select
                            options={locations} // your locations state
                            value={selectedLocations[item.itemName] || null}
                            onChange={(selected) =>
                              handleLocationChange(item.itemName, selected)
                            }
                          />
                        </div>

                        {/* Available Quantity */}
                        <div className="col-md-1">
                          <input
                            type="text"
                            className="form-control"
                            value={availableQuantities[item.itemName] || 0}
                            readOnly
                          />
                        </div>

                        {/* Issued Qty */}
                        <div className="col-md-1">
                          <input
                            type="number"
                            className="form-control"
                            value={item.returnableQuantity}
                            readOnly
                          />
                        </div>

                        {/* Returnable */}
                        {/* <div className="col-md-1">
                          <input
                            type="text"
                            className="form-control"
                            value={item.returnable === "Yes" ? "Yes" : "No"}
                            readOnly
                          />
                        </div> */}

                        {/* Return Qty */}
                        <div className="col-md-2">
                          <input
                            type="number"
                            className="form-control"
                            value={returnQuantities[item.itemName] || ""}
                            onChange={(e) =>
                              handleQuantityChange(item.itemName, e.target.value)
                            }
                            min="0"
                            max={item.issuedQuantity}
                          />
                        </div>

                        {/* UOM */}
                        <div className="col-md-1">
                          <input
                            type="text"
                            className="form-control"
                            value={item.uom}
                            readOnly
                          />
                        </div>

                        {/* Remarks */}
                        <div className="col-md-2">
                          <input
                            type="text"
                            className="form-control"
                            value={returnRemarks[item.itemName] || ""}
                            onChange={(e) => handleRemarksChange(item.itemName, e.target.value)}
                            placeholder="Remarks"
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>


            <button className="btn btn-success mt-3" onClick={generateReturnSlip}>
              Generate Return Slip
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default ReturnSlip;
